import { render, staticRenderFns } from "./RequestErrors.vue?vue&type=template&id=06a13d3c"
import script from "./RequestErrors.vue?vue&type=script&lang=js"
export * from "./RequestErrors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports